import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {HPV_VACCINATION_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/hpv-vaccination/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/hpv-vaccination/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/hpv-vaccination/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/hpv-vaccination/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/hpv-vaccination/Questionnaire5Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const HPVVaccination = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case HPV_VACCINATION_KEYS.START:
        trackPageViewGA('/hpv-vaccination/start', 'MDQ-HPV Vaccination - Start');
        return <Questionnaire1Screen />;
      case HPV_VACCINATION_KEYS.PROFILE:
        trackPageViewGA('/hpv-vaccination/profile', 'MDQ-HPV Vaccination - Profile');
        return <Questionnaire2Screen />;
      case HPV_VACCINATION_KEYS.INVALID:
        trackPageViewGA('/hpv-vaccination/invalid', 'MDQ-HPV Vaccination - Invalid');
        return <Questionnaire3Screen />;
      case HPV_VACCINATION_KEYS.APPOINTMENT_PREFERENCES:
        trackPageViewGA('/hpv-vaccination/appointment-preferences', 'MDQ-HPV Vaccination - Appointment Preferences');
        return <Questionnaire4Screen />;
      case HPV_VACCINATION_KEYS.YOUR_TEST_PACKAGE:
        trackPageViewGA('/hpv-vaccination/your-test-package', 'MDQ-HPV Vaccination - Your Test Package');
        return <Questionnaire5Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default HPVVaccination;
